module.exports = __webpack_public_path__ + "img/thaipost_logo.c3139e40.jpg";